let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("avUcz")).then(() => parcelRequire('7KiVJ'));